import { Box, useTheme } from "@mui/material"
import { ReactElement } from "react"
import { RedocStandalone } from "redoc"

import DataLoadError from "../../components/fallback/dataLoadError"
import useOpenApi from "../../services/middleware/hooks/developer/useOpenApi"

/**
 * Whole page display for the Connect Direct developer documentation. This
 * documentation is displayed using the redoc react library.
 */
const DeveloperPortal = (): ReactElement => {
    const theme = useTheme()
    const { openApiJson, isError } = useOpenApi()
    if (isError) {
        return <DataLoadError />
    }
    return (
        <Box sx={{ backgroundColor: "white" }}>
            <Box sx={{ overflow: "auto", height: "80vh" }}>
                <RedocStandalone
                    spec={openApiJson}
                    options={{
                        hideHostname: true,
                        disableSearch: true,
                        sortPropsAlphabetically: true,
                        theme: {
                            sidebar: {
                                width: "20%",
                                textColor: theme.palette.primary.dark,
                                arrow: {
                                    color: theme.palette.secondary.main,
                                },
                                activeTextColor: theme.palette.secondary.dark,
                            },
                        },
                    }}
                />
            </Box>
        </Box>
    )
}

export default DeveloperPortal
